import { render, staticRenderFns } from "./BulmaCarouselModal.vue?vue&type=template&id=4544daa2"
import script from "./BulmaCarouselModal.vue?vue&type=script&lang=js"
export * from "./BulmaCarouselModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports